import { createStore } from 'vuex'

/**
 * 全局状态管理（占位）
 * - 当前项目主要以组件内局部状态为主；此处保留 Vuex 结构，便于后续集成登录状态、购物车、用户偏好等。
 * - 若暂不需要，可在 `main.ts` 移除 `.use(store)` 并删除本文件。
 */
export default createStore({
  state: {
    // 未来可添加：user、cart、preferences 等
  },
  getters: {
    // 示例：isLoggedIn(state) { return !!state.user }
  },
  mutations: {
    // 示例：setUser(state, payload) { state.user = payload }
  },
  actions: {
    // 示例：async fetchUser({ commit }) { /* ... */ }
  },
  modules: {
    // 结构预留：可将复杂领域拆分为模块
  }
})
